import React from 'react';
import { connect } from 'react-redux';
import sortBy from 'lodash/sortBy';
import get from 'lodash/get';
import partial from 'lodash/partial';
import { bindActionCreators } from 'redux';
import { getAlertsForLevel, getAlertManagerType } from 'extractFromState';
import { toggleAlertShowHide } from 'actions/searchActions';
import { markBusinessAlertAsRead } from 'api/businessAlerts';
import { alertsTypesMap, GUIDE } from 'constants/alerts';
import { getIconForAlert } from 'util/alertUtil';
import { setAlertManagerType } from 'actions/tools/ToolActions';
import { READ } from 'constants/alerts';
import {
  Container,
  BlueBar,
  HeaderSection,
  TitleContainer,
  AlertButton,
  AcknowledgeButton,
  InnerSection,
  Section,
  Title,
} from 'components/tools/alerts/Alerts.styles';
import Alert from './Alert/Alert';

class Alerts extends React.Component {
  state = {
    unreadAlerts: [],
    readAlerts: [],
  };

  async componentDidMount() {
    this.updateAlertsInState();
  }

  async componentDidUpdate(prevProps) {
    if (
      this.props.alerts.length !== prevProps.alerts.length ||
      prevProps.alertManagerType !== this.props.alertManagerType
    ) {
      this.updateAlertsInState();
    }

    const { unreadAlerts, readAlerts } = this.state;

    if ([...unreadAlerts, ...readAlerts].length === 0) {
      return this.handleCloseWindow();
    }
  }

  updateAlertsInState = () => {
    this.setState({
      unreadAlerts: this.getUnreadAlerts(),
      readAlerts: this.getReadAlerts(),
    });
  };

  getAllAlertsForSelectedType = () => {
    const { alertManagerType } = this.props;
    const alerts = Object.values(this.props.alerts).filter((alert) => {
      if (alertManagerType === GUIDE) {
        // alerts with no type should be placed under guide
        return alert.type === GUIDE || !alert.type;
      }

      return alert.type === alertManagerType;
    });

    return alerts;
  };

  getUnreadAlerts = () => {
    const unreadAlerts = this.getAllAlertsForSelectedType().filter((alert) => {
      return alert.readStatus !== READ;
    });

    return sortBy(unreadAlerts, (order) => order.createdAt).reverse();
  };

  getReadAlerts = () => {
    const readAlerts = this.getAllAlertsForSelectedType().filter((alert) => {
      return alert.readStatus === READ;
    });

    return sortBy(readAlerts, (order) => order.createdAt).reverse();
  };

  handleMarkAsRead = (alert) => {
    if (!alert.read) {
      // updates DB
      markBusinessAlertAsRead(alert.id);
    }
    // updates redux
    this.props.toggleAlertShowHide(alert.id);
  };

  handleCloseWindow = () => {
    this.props.setAlertManagerType(null);
  };

  getAlertTypeLabel = () => {
    const { alertManagerType } = this.props;

    return get(alertsTypesMap, `[${alertManagerType}].label`, null);
  };

  render() {
    const { alertManagerType } = this.props;
    const { unreadAlerts, readAlerts } = this.state;

    const alerts = [...unreadAlerts, ...readAlerts].map((alert) => (
      <Alert
        key={alert.id}
        alert={alert}
        renderAcknowledgeButton={
          alert.readStatus !== READ
            ? () => <AcknowledgeButton onClick={partial(this.handleMarkAsRead, alert)}>ACKNOWLEDGE</AcknowledgeButton>
            : undefined
        }
      />
    ));

    return (
      <Container>
        <HeaderSection>
          <TitleContainer>
            <img src={getIconForAlert(alertManagerType)} alt={alertManagerType} />
            <Title>{`${this.getAlertTypeLabel()} alerts`}</Title>
          </TitleContainer>
          <AlertButton onClick={this.handleCloseWindow}>CLOSE</AlertButton>
        </HeaderSection>
        <Section>
          <BlueBar />
          <InnerSection>{alerts}</InnerSection>
        </Section>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  alerts: getAlertsForLevel(state),
  alertManagerType: getAlertManagerType(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleAlertShowHide,
      setAlertManagerType,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
